import { FSMPlan } from 'containers/integrations/fsm-integration/constants';
import routesPath from 'routes/RoutesPath';

export enum FSM_PLANS {
  FIELD_SERVE_LITE = 'field_serve_lite',
  FIELD_SERVE_PLUS = 'field_serve_plus'
}

export const FSM_SHOW_MODAL_PLAN_STATES = [FSMPlan.FSM_LITE, FSMPlan.NO_PLAN];

export const FSM_FREE_PLAN_ROUTES = [
  routesPath.JOBS,
  routesPath.COMMISSION_SETTINGS,
  routesPath.EXTERNAL_COMPANY_SETTINGS,
  routesPath.MAP_VIEWS_SETTINGS,
  routesPath.TAGS,
  routesPath.ADJUSTMENT_SETTINGS
];

export const FSM_UPGRADE_NEEDED_ROUTES = [
  routesPath.ACCOUNTING_PAY_RUNS,
  routesPath.MAPS,
  routesPath.ACCOUNTING_EXTERNAL_COMPANY,
  routesPath.REPORTS,
  routesPath.SERVICE_AREAS_SETTINGS,
  routesPath.PAY_SCHEDULE_SETTINGS
];

export const FSM_ENDED_MODAL_ROUTES = [
  routesPath.MAPS,
  routesPath.ACCOUNTING_EXTERNAL_COMPANY,
  routesPath.REPORTS,
  routesPath.SERVICE_AREAS_SETTINGS,
  routesPath.PAY_SCHEDULE_SETTINGS
];

export const FSM_LITE_ENDED_MODAL_ROUTES = [
  routesPath.CREATE_JOB,
  routesPath.CREATE_TAG,
  routesPath.ADD_EXTERNAL_COMPANY,
  routesPath.CREATE_COMMISSION_RULE,
  routesPath.DUPLICATE_JOB
];

export const FSM_BANNER_ROUTES = [
  ...FSM_FREE_PLAN_ROUTES,
  ...FSM_UPGRADE_NEEDED_ROUTES,
  routesPath.EXPENSE_REPORT,
  routesPath.PAYMENT_REPORT,
  routesPath.COMMISSION_REPORT,
  routesPath.AREA_PERFORMANCE_REPORT,
  routesPath.EXTERNAL_COMPANY_REPORT,
  routesPath.ACCOUNTING_PAY_RUNS_LIST
];
